<template>
  <!-- app二级页面，带标题 -->
  <div class="app-title-page flex-container">
    <hjxHeader :title="pageTitle" ref="hjxHeader"></hjxHeader>
    <div class="body-wrap">
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import hjxHeader from '@/components/common/hjx-header';

export default {
  name: 'app-title-page',
  data() {
    return {};
  },
  watch: {},
  props: {
    title: {
      type: String,
      default() {
        return '';
      },
    },
  },
  components: { hjxHeader },
  computed: {
    pageTitle() {
      return (
        this.title ||
        (this.$route && this.$route.meta && this.$route.meta.pageTitle) ||
        ''
      );
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取头部高度
    getHeaderH() {
      return this.$refs.hjxHeader.$el.offsetHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  padding: 12px 12px 68px;
}
</style>

